import { katTranslator } from '../../shared/i18n';

export const strings = {
  // AST: kat_pagination_page_number_label
  page_number_label: {
    'en-US': 'Page',
    'it-IT': 'Pagina',
    'te-IN': 'పేజీ',
    'tr-TR': 'Sayfa.',
    'bn-IN': 'পেজ',
    'cs-CZ': 'Strana',
    'zh-TW': '頁面',
    'mr-IN': 'पृष्ठ',
    'da-DK': 'Side',
    'ko-KR': '페이지',
    'ml-IN': 'പേജ്',
    'ar-AE': 'الصفحة',
    'ja-JP': 'ページ',
    'nl-BE': 'Pagina',
    'nl-NL': 'Pagina',
    'es-ES': 'Página',
    'hi-IN': 'पेज',
    'pt-PT': 'Página',
    'ta-IN': 'பக்கம்',
    'de-DE': 'Seite',
    'pt-BR': 'Página',
    'he-IL': 'עמוד',
    'zh-CN': '页面',
    'pl-PL': 'Strona',
    'sv-SE': 'Sida',
    'es-MX': 'Página',
    'es-CO': 'Página',
    'kn-IN': 'ಪುಟ',
    'es-US': 'Página',
  },
  // AST: kat_pagination_nav_label
  pagination_label: {
    'en-US': 'Pagination',
    'it-IT': 'Impaginazione',
    'te-IN': 'పేజీనేషన్',
    'tr-TR': 'Sayfa numaralandırma.',
    'bn-IN': 'পেজ সংখ্যার ক্রম',
    'cs-CZ': 'Stránkování',
    'zh-TW': '分頁',
    'mr-IN': 'पृष्ठांकन',
    'da-DK': 'Sideinddeling',
    'ko-KR': '페이지 매기기',
    'ml-IN': 'പേജിനേഷൻ',
    'ar-AE': 'ترقيم الصفحات',
    'ja-JP': 'ページ分割',
    'nl-BE': 'Paginering',
    'nl-NL': 'Paginering',
    'es-ES': 'Paginación',
    'hi-IN': 'पृष्ठांकन',
    'pt-PT': 'Paginação',
    'ta-IN': 'பக்கமிடுதல்',
    'de-DE': 'Paginierung',
    'pt-BR': 'Paginação',
    'he-IL': 'עימוד',
    'zh-CN': '页码',
    'pl-PL': 'Numeracja stron',
    'sv-SE': 'Sidnumrering',
    'es-MX': 'Paginación',
    'es-CO': 'Paginación',
    'kn-IN': 'ಪುಟ ವಿನ್ಯಾಸ',
    'es-US': 'Paginación',
  },
  // AST: kat_pagination_back_navigation_label
  back_navigation_label: {
    'en-US': 'Navigate back',
    'it-IT': 'Vai indietro',
    'te-IN': 'వెనుకకు నావిగేట్ చేయండి',
    'tr-TR': 'Geri git.',
    'bn-IN': 'পেছনে ফিরে আসুন',
    'cs-CZ': 'Vrátit zpět',
    'zh-TW': '向後巡覽',
    'mr-IN': 'मागे नेव्हिगेट करा',
    'da-DK': 'Naviger tilbage',
    'ko-KR': '뒤로 이동',
    'ml-IN': 'പിന്നിലേക്ക് നാവിഗേറ്റ് ചെയ്യുക',
    'fr-FR': 'Naviguez vers l’arrière',
    'fr-BE': 'Naviguer vers l’arrière',
    'ar-AE': 'انتقل إلى الخلف',
    'ja-JP': '後ろに戻る',
    'nl-BE': 'Navigeer terug',
    'nl-NL': 'Navigeer terug',
    'es-ES': 'Navegar hacia atrás',
    'hi-IN': 'वापस नेविगेट करें',
    'pt-PT': 'Navegar para trás',
    'ta-IN': 'பின்னோக்கிச் செல்',
    'de-DE': 'Zurück navigieren',
    'pt-BR': 'Voltar',
    'he-IL': 'לנווט אחורה',
    'zh-CN': '向后巡览',
    'pl-PL': 'Przejdź wstecz',
    'fr-CA': 'Naviguer vers l’arrière',
    'sv-SE': 'Navigera tillbaka',
    'es-MX': 'Navegar hacia atrás',
    'es-CO': 'Retroceder',
    'kn-IN': 'ಹಿಂದಕ್ಕೆ ನ್ಯಾವಿಗೇಟ್ ಮಾಡಿ',
    'es-US': 'Navegar hacia atrás',
  },
  // AST: kat_pagination_forward_navigation_label
  forward_navigation_label: {
    'en-US': 'Navigate forward',
    'it-IT': 'Vai avanti',
    'te-IN': 'ముందుకు నావిగేట్ చేయండి',
    'tr-TR': 'İleri git.',
    'bn-IN': 'সামনের দিকে যান',
    'cs-CZ': 'Pokračovat vpřed',
    'zh-TW': '向前巡覽',
    'mr-IN': 'पुढे नेव्हिगेट करा',
    'da-DK': 'Naviger fremad',
    'ko-KR': '앞으로 이동',
    'ml-IN': 'മുന്നോട്ട് നാവിഗേറ്റ് ചെയ്യുക',
    'fr-FR': "Naviguer vers l'avant",
    'fr-BE': "Naviguer vers l'avant",
    'ar-AE': 'انتقل إلى الأمام',
    'ja-JP': '前に進む',
    'nl-BE': 'Navigeer vooruit',
    'nl-NL': 'Navigeer vooruit',
    'es-ES': 'Navegar hacia adelante',
    'hi-IN': 'आगे नेविगेट करें',
    'pt-PT': 'Navegar em frente',
    'ta-IN': 'முன்னோக்கிச் செல்',
    'de-DE': 'Vorwärts navigieren',
    'pt-BR': 'Avançar',
    'he-IL': 'לנווט קדימה',
    'zh-CN': '向前巡览',
    'pl-PL': 'Przejdź dalej',
    'fr-CA': 'Naviguer vers l’avant',
    'sv-SE': 'Navigera framåt',
    'es-MX': 'Navegar hacia adelante',
    'es-CO': 'Avanzar',
    'kn-IN': 'ಮುಂದೆ ನ್ಯಾವಿಗೇಟ್ ಮಾಡಿ',
    'es-US': 'Navegar hacia adelante',
  },
};

export default katTranslator(strings);
